function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["unit", "utc"],
  _excluded2 = ["timeUnit"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { getBandPosition, vgField } from '../../channeldef';
import { getDateTimePartAndStep, getSmallestTimeUnitPart, getTimeUnitParts, isBinnedTimeUnit, normalizeTimeUnit } from '../../timeunit';
import { accessWithDatumToUnescapedPath, duplicate, entries, hash as _hash, isEmpty, replacePathInField, vals } from '../../util';
import { isUnitModel } from '../model';
import { DataFlowNode } from './dataflow';
import { isRectBasedMark } from '../../mark';
import { isXorY } from '../../channel';
function isTimeUnitTransformComponent(timeUnitComponent) {
  return timeUnitComponent.as !== undefined;
}
function offsetAs(field) {
  return "".concat(field, "_end");
}
export var TimeUnitNode = /*#__PURE__*/function (_DataFlowNode) {
  function TimeUnitNode(parent, timeUnits) {
    var _this;
    _classCallCheck(this, TimeUnitNode);
    _this = _callSuper(this, TimeUnitNode, [parent]);
    _this.timeUnits = timeUnits;
    return _this;
  }
  _inherits(TimeUnitNode, _DataFlowNode);
  return _createClass(TimeUnitNode, [{
    key: "clone",
    value: function clone() {
      return new TimeUnitNode(null, duplicate(this.timeUnits));
    }
  }, {
    key: "merge",
    value:
    /**
     * Merge together TimeUnitNodes assigning the children of `other` to `this`
     * and removing `other`.
     */
    function merge(other) {
      this.timeUnits = _objectSpread({}, this.timeUnits);
      // if the same hash happen twice, merge
      for (var key in other.timeUnits) {
        if (!this.timeUnits[key]) {
          // copy if it's not a duplicate
          this.timeUnits[key] = other.timeUnits[key];
        }
      }
      var _iterator = _createForOfIteratorHelper(other.children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          other.removeChild(child);
          child.parent = this;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      other.remove();
    }
    /**
     * Remove time units coming from the other node.
     */
  }, {
    key: "removeFormulas",
    value: function removeFormulas(fields) {
      var newFormula = {};
      var _iterator2 = _createForOfIteratorHelper(entries(this.timeUnits)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref = _step2.value;
          var _ref2 = _slicedToArray(_ref, 2);
          var key = _ref2[0];
          var timeUnitComponent = _ref2[1];
          var fieldAs = isTimeUnitTransformComponent(timeUnitComponent) ? timeUnitComponent.as : "".concat(timeUnitComponent.field, "_end");
          if (!fields.has(fieldAs)) {
            newFormula[key] = timeUnitComponent;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.timeUnits = newFormula;
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(vals(this.timeUnits).map(function (f) {
        return isTimeUnitTransformComponent(f) ? f.as : offsetAs(f.field);
      }));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(vals(this.timeUnits).map(function (f) {
        return f.field;
      }));
    }
  }, {
    key: "hash",
    value: function hash() {
      return "TimeUnit ".concat(_hash(this.timeUnits));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var transforms = [];
      var _iterator3 = _createForOfIteratorHelper(vals(this.timeUnits)),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var f = _step3.value;
          var rectBandPosition = f.rectBandPosition;
          var normalizedTimeUnit = normalizeTimeUnit(f.timeUnit);
          if (isTimeUnitTransformComponent(f)) {
            var field = f.field,
              as = f.as;
            var unit = normalizedTimeUnit.unit,
              utc = normalizedTimeUnit.utc,
              params = _objectWithoutProperties(normalizedTimeUnit, _excluded);
            var startEnd = [as, "".concat(as, "_end")];
            transforms.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
              field: replacePathInField(field),
              type: 'timeunit'
            }, unit ? {
              units: getTimeUnitParts(unit)
            } : {}), utc ? {
              timezone: 'utc'
            } : {}), params), {}, {
              as: startEnd
            }));
            transforms.push.apply(transforms, _toConsumableArray(offsetedRectFormulas(startEnd, rectBandPosition, normalizedTimeUnit)));
          } else if (f) {
            var escapedField = f.field;
            // since this is a expression, we want the unescaped field name
            var _field = escapedField.replaceAll('\\.', '.');
            var expr = offsetExpr({
              timeUnit: normalizedTimeUnit,
              field: _field
            });
            var endAs = offsetAs(_field);
            transforms.push({
              type: 'formula',
              expr: expr,
              as: endAs
            });
            transforms.push.apply(transforms, _toConsumableArray(offsetedRectFormulas([_field, endAs], rectBandPosition, normalizedTimeUnit)));
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return transforms;
    }
  }], [{
    key: "makeFromEncoding",
    value: function makeFromEncoding(parent, model) {
      var formula = model.reduceFieldDef(function (timeUnitComponent, fieldDef, channel) {
        var field = fieldDef.field,
          timeUnit = fieldDef.timeUnit;
        if (timeUnit) {
          var component;
          if (isBinnedTimeUnit(timeUnit)) {
            // For binned time unit, only produce end if the mark is a rect-based mark (rect, bar, image, arc), which needs "range".
            if (isUnitModel(model)) {
              var mark = model.mark,
                markDef = model.markDef,
                config = model.config;
              var bandPosition = getBandPosition({
                fieldDef: fieldDef,
                markDef: markDef,
                config: config
              });
              if (isRectBasedMark(mark) || !!bandPosition) {
                component = {
                  timeUnit: normalizeTimeUnit(timeUnit),
                  field: field
                };
              }
            }
          } else {
            component = {
              as: vgField(fieldDef, {
                forAs: true
              }),
              field: field,
              timeUnit: timeUnit
            };
          }
          if (isUnitModel(model)) {
            var _mark = model.mark,
              _markDef = model.markDef,
              _config = model.config;
            var _bandPosition = getBandPosition({
              fieldDef: fieldDef,
              markDef: _markDef,
              config: _config
            });
            if (isRectBasedMark(_mark) && isXorY(channel) && _bandPosition !== 0.5) {
              component.rectBandPosition = _bandPosition;
            }
          }
          if (component) {
            timeUnitComponent[_hash(component)] = component;
          }
        }
        return timeUnitComponent;
      }, {});
      if (isEmpty(formula)) {
        return null;
      }
      return new TimeUnitNode(parent, formula);
    }
  }, {
    key: "makeFromTransform",
    value: function makeFromTransform(parent, t) {
      var _t = _objectSpread({}, t),
        timeUnit = _t.timeUnit,
        other = _objectWithoutProperties(_t, _excluded2);
      var normalizedTimeUnit = normalizeTimeUnit(timeUnit);
      var component = _objectSpread(_objectSpread({}, other), {}, {
        timeUnit: normalizedTimeUnit
      });
      return new TimeUnitNode(parent, _defineProperty({}, _hash(component), component));
    }
  }]);
}(DataFlowNode);
export var OFFSETTED_RECT_START_SUFFIX = 'offsetted_rect_start';
export var OFFSETTED_RECT_END_SUFFIX = 'offsetted_rect_end';
function offsetExpr(_ref3) {
  var timeUnit = _ref3.timeUnit,
    field = _ref3.field,
    reverse = _ref3.reverse;
  var unit = timeUnit.unit,
    utc = timeUnit.utc;
  var smallestUnit = getSmallestTimeUnitPart(unit);
  var _getDateTimePartAndSt = getDateTimePartAndStep(smallestUnit, timeUnit.step),
    part = _getDateTimePartAndSt.part,
    step = _getDateTimePartAndSt.step;
  var offsetFn = utc ? 'utcOffset' : 'timeOffset';
  var expr = "".concat(offsetFn, "('").concat(part, "', ").concat(accessWithDatumToUnescapedPath(field), ", ").concat(reverse ? -step : step, ")");
  return expr;
}
function offsetedRectFormulas(_ref4, rectBandPosition, timeUnit) {
  var _ref5 = _slicedToArray(_ref4, 2),
    startField = _ref5[0],
    endField = _ref5[1];
  if (rectBandPosition !== undefined && rectBandPosition !== 0.5) {
    var startExpr = accessWithDatumToUnescapedPath(startField);
    var endExpr = accessWithDatumToUnescapedPath(endField);
    return [{
      type: 'formula',
      expr: interpolateExpr([offsetExpr({
        timeUnit: timeUnit,
        field: startField,
        reverse: true
      }), startExpr], rectBandPosition + 0.5),
      as: "".concat(startField, "_").concat(OFFSETTED_RECT_START_SUFFIX)
    }, {
      type: 'formula',
      expr: interpolateExpr([startExpr, endExpr], rectBandPosition + 0.5),
      as: "".concat(startField, "_").concat(OFFSETTED_RECT_END_SUFFIX)
    }];
  }
  return [];
}
function interpolateExpr(_ref6, fraction) {
  var _ref7 = _slicedToArray(_ref6, 2),
    start = _ref7[0],
    end = _ref7[1];
  return "".concat(1 - fraction, " * ").concat(start, " + ").concat(fraction, " * ").concat(end);
}